import React, {useEffect, useState} from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// tremor
import {TabList as TremorTabList, Tab } from "@tremor/react";
 
const TabList = (props) => {

    const [tab, setTab] = useState(1)

    useEffect(() => {
        props.setTab(tab)
    }, [tab]);

    return (
        <TremorTabList
            defaultValue={ 1 }
            handleSelect={(value)=>{ setTab(value)}}
            marginTop="mt-5"
        >
            { props.tabs.map((tab, index) => 
                <Tab value={index+1} text={tab} />
            )}
        </TremorTabList>
    );
};

export default TabList;